const Data = [
  {
    id: 4,
    category: "Experience",
    icon: "uil-briefcase-alt",
    year: "June 2022 - Present",
    title: "Software Developer",
    subtitle: 'JMM InfoTech',
    desc: "Lorem ipsum dolor sit amet quo ei simul congue exerciad nec admodum perfecto.",
  },    
  {
      id: 1,
      category: "Education",
      icon: "uil-graduation-cap",
      year: "2021 - 2023",
      title: "M.Sc. Information Technology Degree",
      subtitle: 'RJ College',
      desc: "Lorem ipsum dolor sit amet quo ei simul congue exerciad nec admodum perfecto.",
    },
    {
      id: 2,
      category: "Education",
      icon: "uil-graduation-cap",
      year: "2017 - 2020",
      title: "B.Sc. Information Technology Degree",
      subtitle: 'KJ Somaiya',
      desc: "Lorem ipsum dolor sit amet quo ei simul congue exerciad nec admodum perfecto.",
    },
    {
      id: 3,
      category: "Education",
      icon: "uil-graduation-cap",
      year: "2016 - 2017",
      title: "Senior Secondary (XII) - Science Stream",
      subtitle: 'S. N. B.',
      desc: "Lorem ipsum dolor sit amet quo ei simul congue exerciad nec admodum perfecto.",
    },
    
  
    {
        id: 6,
        category: "Education",
        icon: "uil-graduation-cap",
        year: "2014 - 2015",
        title: "Secondary (X) - Hindi Medium",
        subtitle: 'Y. S. K. V.',
        desc: "Lorem ipsum dolor sit amet quo ei simul congue exerciad nec admodum perfecto.",
      },
      {
        id: 7,
        category: "Experience",
        icon: "uil-briefcase-alt",
        year: "Apr 2018 - Jun 2022",
        title: "Freelancer",
        subtitle: 'Self Employee',
        desc: "Lorem ipsum dolor sit amet quo ei simul congue exerciad nec admodum perfecto.",
      }
  ];

export default Data